export default __webpack_public_path__ + "static/media/giftIcon.a065ff3d.svg";